import { render, staticRenderFns } from "./DistributionList.vue?vue&type=template&id=1aec3738&"
import script from "./DistributionList.vue?vue&type=script&lang=js&"
export * from "./DistributionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports